import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { inject } from '@ember/service';
import { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{! Octane/Glimmer: sintassi angle bracket, @args, e best practice }}\n<div class=\'grid-x index-filter show-for-small-only align-center\'>\n  <div class=\'cell shrink\'>\n    <button\n      type=\'button\'\n      class=\'button flat\'\n      aria-expanded={{if this.showFilter \'true\' \'false\'}} data-test-set-show-filter {{on \'click\' (fn (mut this.showFilter) (not this.showFilter))}}\n    >\n      {{t \'more filter\'}}\n    </button>\n  </div>\n</div>\n\n{{#if this.showFilter}}\n  <div class=\'grid-x index-filter\'>\n    <div class=\'cell small-3 medium-shrink\'>\n      <button\n        type=\'button\'\n        class=\'button\'\n        aria-label={{t \'filter options\'}}\n        data-toggle={{this.zfOrFilter}}\n      >\n        <FaIcon @icon=\'sliders\' aria-hidden=\'true\' />\n        <FaIcon @icon=\'chevron-down\' aria-hidden=\'true\' />\n      </button>\n      <BbDropdown @id={{this.zfOrFilter}}>\n        <ul class=\'menu vertical text-left drop-select-period\'>\n          <li>\n            <LinkTo @query={{hash all_any=\'all\'}}>\n              {{t \'that match all filters\'}}\n            </LinkTo>\n          </li>\n          <li>\n            <LinkTo @query={{hash all_any=\'any\'}}>\n              {{t \'that match any filters\'}}\n            </LinkTo>\n          </li>\n        </ul>\n      </BbDropdown>\n    </div>\n    <div class=\'cell small-4 medium-auto\'>\n      <div class=\'button-group\'>\n        {{#if @showAdvancedContact}}\n          <div\n            class=\'button\n              {{if this.fromContactIds.length \"selected\"}}\n              {{if this.contactIds.length \"selected\"}}\' data-test-set-show-contact-modal {{on \'click\' (fn (mut this.showContactModal) true)}}\n          >\n            <FaIcon @icon=\'users\' role=\'presentation\' />\n            {{this.session.me.organization.contacts_name}}\n            {{#if this.totalContactsCount}}\n              <span class=\'label primary\'>{{this.totalContactsCount}}</span>\n            {{/if}}\n          </div>\n        {{else}}\n          <div\n            class=\'button {{if this.contactIds.length \"selected\"}}\' data-test-set-show-contact-modal-2 {{on \'click\' (fn (mut this.showContactModal) true)}}\n          >\n            <FaIcon @icon=\'users\' role=\'presentation\' />\n            {{this.session.me.organization.contact_name}}\n            {{#if this.contactIds.length}}\n              <span class=\'label primary\'>{{this.contactIds.length}}</span>\n            {{/if}}\n          </div>\n        {{/if}}\n        <div\n          class=\'button {{if this.productIds.length \"selected\"}}\' data-test-set-show-product-modal {{on \'click\' (fn (mut this.showProductModal) true)}}\n        >\n          <FaIcon @icon=\'shopping-basket\' role=\'presentation\' />\n          {{this.session.me.organization.product_name}}\n          {{#if this.productIds.length}}\n            <span class=\'label primary\'>{{this.productIds.length}}</span>\n          {{/if}}\n        </div>\n      </div>\n    </div>\n    {{#if this.showEventFilter}}\n      <div class=\'cell shrink\'>\n        <span\n          class=\'button\n            {{if this.indexContext.controller.gdpr \"selected\"}}\n            {{if (is-equal this.indexContext.controller.type \"pacchetti\") \"selected\"}}\'\n          role=\'button\'\n          data-toggle=\'{{this.zfPazFilter}}\'\n        >\n          <FaIcon @icon=\'user\' />\n          {{#if (is-equal this.indexContext.controller.type \'pacchetti\')}}\n            {{t \'packages\'}}\n          {{else if (is-equal this.indexContext.controller.gdpr \'3\')}}\n            {{t \'with patient\'}}\n          {{else if (is-equal this.indexContext.controller.gdpr \'2\')}}\n            {{t \'without patient\'}}\n          {{else if (is-equal this.indexContext.controller.gdpr \'4\')}}\n            {{t \'group events\'}}\n          {{else}}\n            {{t \'all\'}}\n          {{/if}}\n          <FaIcon @icon=\'chevron-down\' />\n        </span>\n\n        <BbDropdown @id={{this.zfPazFilter}}>\n          <ul class=\'menu vertical text-left\'>\n            <li>\n              <a\n                class=\'{{if (is-equal this.indexContext.controller.gdpr \"\") \"active\"}}\n                  {{if\n                    this.indexContext.controller.gdpr\n                    \"\"\n                    (if (is-equal this.indexContext.controller.type \"events\") \"active\")\n                  }}\'\n                data-test-set-gdpr\n                {{on \'click\' (fn this.setGdpr \'\')}}\n              >\n                {{t \'all\'}}\n              </a>\n            </li>\n            <li>\n              <a\n                class=\'{{if (is-equal this.indexContext.controller.gdpr \"4\") \"active\"}}\'\n                data-test-set-gdpr-2\n                {{on \'click\' (fn this.setGdpr \'4\')}}\n              >\n                {{t \'group events\'}}\n              </a>\n            </li>\n            <li>\n              <a\n                class=\'{{if (is-equal this.indexContext.controller.type \"pacchetti\") \"active\"}}\'\n                data-test-set-type\n                {{on \'click\' (fn this.setType \'pacchetti\')}}\n              >\n                {{t \'packages\'}}\n              </a>\n            </li>\n            <li>\n              <a\n                class=\'{{if (is-equal this.indexContext.controller.gdpr \"3\") \"active\"}}\'\n                data-test-set-gdpr-3\n                {{on \'click\' (fn this.setGdpr \'3\')}}\n              >\n                {{t \'with patient\'}}\n              </a>\n            </li>\n            <li>\n              <a\n                class=\'{{if (is-equal this.indexContext.controller.gdpr \"2\") \"active\"}}\'\n                data-test-set-gdpr-4\n                {{on \'click\' (fn this.setGdpr \'2\')}}\n              >\n                {{t \'without patient\'}}\n              </a>\n            </li>\n          </ul>\n        </BbDropdown>\n      </div>\n    {{/if}}\n    {{#if this.showSelectPayment}}\n      <div class=\'cell small-6 medium-shrink\'>\n        <div\n          class=\'button {{if this.indexContext.controller.pMethod \"selected\"}}\'\n          data-toggle=\'pMethodList\'\n        >\n          {{#if this.indexContext.controller.pMethod}}\n            {{this.indexContext.controller.pMethod.name}}\n          {{else}}\n            {{t \'payment method\'}}\n          {{/if}}\n          <FaIcon @icon=\'chevron-down\' />\n        </div>\n        <BbDropdown @id=\'pMethodList\'>\n          <ul class=\'vertical menu action-sheet-scroll-box\'>\n            {{#each this.session.payment_methods as |pm|}}\n              <li>\n                <a\n                  class=\'list-group-item\'\n                  data-test-set-pmethod\n                  {{on \'click\' (fn this.setPMethod pm.name pm)}}\n                >\n                  {{pm.name}}\n                </a>\n              </li>\n            {{/each}}\n          </ul>\n        </BbDropdown>\n      </div>\n      <div class=\'cell small-6 medium-shrink\'>\n        <span\n          class=\'button\n            {{if this.indexContext.controller.success \"selected\"}}\n            {{if this.indexContext.controller.voucher \"selected\"}}\n            {{if this.indexContext.controller.status \"selected\"}}\'\n          role=\'button\'\n          data-toggle={{this.zfEsitoFilter}}\n        >\n          <FaIcon @icon=\'filter\' role=\'presentation\' />\n          {{#if (is-equal this.indexContext.controller.status \'invoiced\')}}\n            {{t \'invoiceds\'}}\n          {{/if}}\n          {{#if (is-equal this.indexContext.controller.status \'scontrinati\')}}\n            {{t \'scontrinati\'}}\n          {{/if}}\n          {{#if (is-equal this.indexContext.controller.status \'not_invoiced\')}}\n            {{t \'not invoiced or billed\'}}\n          {{/if}}\n          {{#if (is-equal this.indexContext.controller.status \'others\')}}\n            {{t \'others\'}}\n          {{/if}}\n          {{#if this.indexContext.controller.voucher}}\n            {{t \'voucher\'}}\n          {{/if}}\n          {{#if this.indexContext.controller.success}}\n            {{t \'success\'}}\n          {{/if}}\n          {{t \'filter\'}}\n          <FaIcon @icon=\'chevron-down\' role=\'presentation\' />\n        </span>\n        <BbDropdown @id={{this.zfEsitoFilter}}>\n          <h4 class=\'label hollow\'>\n            {{t \'result\'}}\n          </h4>\n          <ul class=\'menu vertical text-left drop-select-period\'>\n            <li>\n              <LinkTo @query={{hash success=null}}>\n                {{t \'all\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash success=true}}>\n                {{t \'success\'}}\n              </LinkTo>\n            </li>\n          </ul>\n          <h4 class=\'label hollow\'>\n            {{this.session.me.organization.invoice_name}}\n          </h4>\n          <ul class=\'menu vertical text-left drop-select-period\'>\n            <li>\n              <LinkTo @query={{hash status=null}}>\n                {{t \'all\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash status=\'invoiced\'}}>\n                {{t \'invoiceds\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash status=\'scontrinati\'}}>\n                {{t \'scontrinati\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash status=\'not_invoiced\'}}>\n                {{t \'not invoiced or billed\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash status=\'others\'}}>\n                {{t \'others\'}}\n              </LinkTo>\n            </li>\n          </ul>\n          <h4 class=\'label hollow\'>\n            {{t \'voucher\'}}\n          </h4>\n          <ul class=\'menu vertical text-left drop-select-period\'>\n            <li>\n              <LinkTo @query={{hash voucher=null}}>\n                {{t \'all\'}}\n              </LinkTo>\n            </li>\n            <li>\n              <LinkTo @query={{hash voucher=true}}>\n                {{t \'voucher\'}}\n              </LinkTo>\n            </li>\n          </ul>\n        </BbDropdown>\n      </div>\n    {{/if}}\n    {{#if this.showSelectCategory}}\n      <div class=\'cell shrink\'>\n        <span\n          role=\'button\'\n          class=\'button {{if this.category \"selected\"}}\' data-test-set-select-category-slide {{on \'click\' (fn (mut this.selectCategorySlide) true)}}\n        >\n          <FaIcon @icon=\'tag\' role=\'presentation\' />\n          {{t \'select category\'}}\n          {{#if this.category.length}}\n            <span class=\'label primary\'>{{this.category.length}}</span>\n          {{/if}}\n        </span>\n      </div>\n    {{/if}}\n    {{#if this.showCreditNote}}\n      <div class=\'cell shrink\'>\n        <span\n          class=\'button\n            {{if this.indexContext.controller.sdi_status \"selected\"}}\n            {{if this.indexContext.controller.success \"selected\"}}\'\n          role=\'button\' data-toggle={{this.zfStatoinvFilter}} data-test-set-e-inv {{on \'click\' (fn (mut this.eInv) false)}}\n          {{on \'click\' (fn (mut this.tsInv) false)}}\n        >\n          <FaIcon @icon=\'list\' role=\'presentation\' />\n          {{#if this.indexContext.controller.sdi_status}}\n            {{this.indexContext.controller.sdi_status}}\n            {{#if this.indexContext.controller.success}}\n              {{t \'credit note\'}}\n            {{/if}}\n          {{else if this.indexContext.controller.success}}\n            {{t \'credit note\'}}\n          {{else}}\n            {{t \'status\'}}\n          {{/if}}\n          <FaIcon @icon=\'chevron-down\' role=\'presentation\' />\n        </span>\n        <BbDropdown @id={{this.zfStatoinvFilter}}>\n          <ul class=\'menu vertical text-left drop-select-period\'>\n            {{#if this.showStatusSdi}}\n              {{#unless (or this.eInv this.tsInv)}}\n                <li>\n                  <a data-test-set-status {{on \'click\' (fn this.setStatus null)}}>\n                    {{t \'show all documents\'}}\n                  </a>\n                </li>\n              {{/unless}}\n\n              <li class=\'slide-line {{if this.tsInv \"hide\"}}\'>\n                <div class=\'grid-x {{if this.eInv \"line-active\" \"line-disactive\"}}\'>\n                  <div class=\'cell auto\'>\n                    <ul class=\'menu vertical text-left\'>\n                      <li>\n                        <a data-test-set-e-inv-2 {{on \'click\' (fn (mut this.eInv) (not this.eInv))}}>\n                          <FaIcon @icon=\'angle-left\' />\n                          <span class=\'text-secondary\'>\n                            {{t \'electronic invoice\'}}\n                          </span>\n                        </a>\n                      </li>\n                      {{#each this.sdiStates as |s|}}\n                        <li>\n                          <a\n                            class=\'{{if\n                                (is-equal this.indexContext.controller.sdi_status s.status)\n                                \"active\"\n                              }}\'\n                            data-test-set-status-2\n                            {{on \'click\' (fn this.setStatus s.status)}}\n                          >\n                            {{t s.name}}\n                          </a>\n                        </li>\n                      {{/each}}\n                    </ul>\n                  </div>\n                </div>\n\n                <a\n                  class=\'{{if this.eInv \"line-disactive-link\" \"line-active\"}}\' data-test-set-e-inv-3 {{on \'click\' (fn (mut this.eInv) (not this.eInv))}}\n                >\n                  {{t \'electronic invoice\'}}\n                  <FaIcon @icon=\'angle-right\' @pull=\'right\' />\n                </a>\n              </li>\n\n              <li class=\'slide-line {{if this.eInv \"hide\"}}\'>\n                <div class=\'grid-x {{if this.tsInv \"line-active\" \"line-disactive\"}}\'>\n                  <div class=\'cell auto\'>\n                    <ul class=\'menu vertical text-left\'>\n                      <li>\n                        <a data-test-set-ts-inv {{on \'click\' (fn (mut this.tsInv) (not this.tsInv))}}>\n                          <FaIcon @icon=\'angle-left\' />\n                          <span class=\'text-secondary\'>\n                            {{t \'TS system\'}}\n                          </span>\n                        </a>\n                      </li>\n\n                      {{#each this.tsStates as |s|}}\n                        <li>\n                          <a\n                            class=\'{{if\n                                (is-equal this.indexContext.controller.sdi_status s.status)\n                                \"active\"\n                              }}\'\n                            data-test-set-status-3\n                            {{on \'click\' (fn this.setStatus s.status)}}\n                          >\n                            {{t s.name}}\n                          </a>\n                        </li>\n                      {{/each}}\n                    </ul>\n                  </div>\n                </div>\n\n                <a\n                  class=\'{{if this.tsInv \"line-disactive-link\" \"line-active\"}}\' data-test-set-ts-inv-2 {{on \'click\' (fn (mut this.tsInv) (if this.tsInv false true))}}\n                >\n                  {{t \'TS system\'}}\n                  <FaIcon @icon=\'angle-right\' @pull=\'right\' />\n                </a>\n              </li>\n            {{/if}}\n\n            {{#if this.showCreditNote}}\n              {{#unless (or this.eInv this.tsInv)}}\n                <li>\n                  <a\n                    class=\'{{unless this.indexContext.controller.success \"active\"}}\'\n                    data-test-set-success\n                    {{on \'click\' (fn this.setSuccess null)}}\n                  >\n                    {{t \'show all documents\'}}\n                  </a>\n                </li>\n                <li>\n                  <a\n                    class=\'{{if this.indexContext.controller.success \"active\"}}\'\n                    data-test-set-success-2\n                    {{on \'click\' (fn this.setSuccess true)}}\n                  >\n                    {{t \'only credit note\'}}\n                  </a>\n                </li>\n              {{/unless}}\n            {{/if}}\n          </ul>\n        </BbDropdown>\n      </div>\n    {{/if}}\n    <div class=\'cell drop-select-period shrink\'>\n      <BbPeriodPicker\n        @applicationController={{@applicationController}}\n        @fromDate={{this.indexContext.controller.from_date}}\n        @toDate={{this.indexContext.controller.to_date}}\n        @year={{this.indexContext.controller.year}}\n        @pag={{this.indexContext.controller.pag}}\n        @action={{this.setPeriod}}\n        @setFromDate={{this.setFromDate}}\n        @setToDate={{this.setToDate}} data-test-set-period\n      />\n    </div>\n  </div>\n{{/if}}\n{{#if\n  (or\n    this.contactIds.length\n    this.productIds.length\n    this.fromContactIds.length\n    this.category.length\n    this.indexContext.controller.sdi_status\n  )\n}}\n  <div class=\'index-filter-chips\'>\n    {{#each this.contacts as |c|}}\n      <span class=\'filter-chip label primary\'>\n        <FaIcon @icon=\'users\' role=\'presentation\' />\n        <span class=\'chip-label\'>\n          {{c.label}}\n        </span>\n        <a\n          role=\'button\'\n          aria-label=\'{{t \"remove\"}}\'\n          data-test-remove-contact\n          {{on \'click\' (fn this.removeContact c)}}\n        >\n          <FaIcon @icon=\'times\' role=\'presentation\' />\n        </a>\n      </span>\n    {{/each}}\n    {{#each this.from_contacts as |c|}}\n      <span class=\'filter-chip label primary\'>\n        <FaIcon @icon=\'users\' role=\'presentation\' />\n        <span class=\'chip-label\'>\n          {{c.label}}\n        </span>\n        <a\n          role=\'button\'\n          aria-label=\'{{t \"remove\"}}\'\n          data-test-remove-from-contact\n          {{on \'click\' (fn this.removeFromContact c)}}\n        >\n          <FaIcon @icon=\'times\' role=\'presentation\' />\n        </a>\n      </span>\n    {{/each}}\n    {{#each this.products as |c|}}\n      <span class=\'filter-chip label primary\'>\n        <FaIcon @icon=\'shopping-basket\' role=\'presentation\' />\n        <span class=\'chip-label\'>\n          {{c.label}}\n        </span>\n        <a\n          role=\'button\'\n          aria-label=\'{{t \"remove\"}}\'\n          data-test-remove-product\n          {{on \'click\' (fn this.removeProduct c)}}\n        >\n          <FaIcon @icon=\'times\' role=\'presentation\' />\n        </a>\n      </span>\n    {{/each}}\n    {{#each this.category as |c|}}\n      <span class=\'filter-chip label primary\'>\n        <FaIcon @icon=\'tag\' role=\'presentation\' />\n        <span class=\'chip-label\'>\n          {{c.name}}\n        </span>\n        <a\n          role=\'button\'\n          aria-label=\'{{t \"remove\"}}\'\n          data-test-select-category\n          {{on \'click\' (fn this.selectCategory null)}}\n        >\n          <FaIcon @icon=\'times\' role=\'presentation\' />\n        </a>\n      </span>\n    {{/each}}\n    {{#if this.indexContext.controller.sdi_status}}\n      <span class=\'filter-chip label primary\'>\n        <FaIcon @icon=\'file-invoice\' role=\'presentation\' />\n        <span class=\'chip-label\'>\n          {{this.indexContext.controller.sdi_status}}\n        </span>\n        <a\n          role=\'button\'\n          aria-label=\'{{t \"remove\"}}\'\n          data-test-clear-sdi-status\n          {{on \'click\' this.clearSdiStatus}}\n        >\n          <FaIcon @icon=\'times\' role=\'presentation\' />\n        </a>\n      </span>\n    {{/if}}\n    <a\n      role=\'button\'\n      class=\'filter-chip-clear\'\n      data-test-clear-all-filters\n      {{on \'click\' this.clearAllFilters}}\n    >\n      <FaIcon @icon=\'times-circle\' role=\'presentation\' />\n      {{t \'remove all filters\'}}\n    </a>\n  </div>\n{{/if}}\n\n<BbModalModern\n  @isOpen={{this.showContactModal}}\n  @title={{t \'filter\'}}\n  @closeOnBackdrop={{true}}\n  @onClose={{fn (mut this.showContactModal) false}}\n  @zIndex=\'13\' data-test-set-show-contact-modal-3\n>\n  <:main>\n    {{#if @showAdvancedContact}}\n      <h4 class=\'label hollow\'>\n        {{t \'filter\'}} {{t \'invoice from\'}}\n      </h4>\n      <small class=\'float-right\'>\n        <a data-test-show-all {{on \'click\' (fn this.showAll \'from_id\')}}>\n          {{t \'all\'}}\n        </a>\n        -\n        <a data-test-only-me-from {{on \'click\' this.onlyMeFrom}}>\n          {{t \'only mine\'}}\n        </a>\n      </small>\n      {{#if this.defaultInvoiceLists}}\n        <div class=\'button-group\'>\n          {{#each this.defaultInvoiceLists as |df|}}\n            <span\n              class=\'button\'\n              role=\'button\'\n              data-test-add-from-contact\n              {{on \'click\' (fn this.addFromContact df.id)}}\n            >\n              {{df.name}}\n            </span>\n          {{/each}}\n        </div>\n      {{/if}}\n      <div class=\'button-group\'>\n        <span\n          role=\'button\'\n          class=\'button small\n            {{if\n              this.indexContext.controller.sezionale\n              \"\"\n              (if (is-equal this.indexContext.controller.sezionale 0) \"\" \"success\")\n            }}\' data-test-set-sezionale {{on \'click\' (fn (mut this.indexContext.controller.sezionale) null)}}\n        >\n          {{t \'all\'}} {{t \'sectional\'}}\n        </span>\n        <span\n          role=\'button\'\n          class=\'button small {{if (eq this.indexContext.controller.sezionale 0) \"success\"}}\' data-test-set-sezionale-2 {{on \'click\' (fn (mut this.indexContext.controller.sezionale) 0)}}\n        >\n          #\n        </span>\n        {{#if this.from_contacts.length}}\n          {{#each this.from_contacts as |c|}}\n            {{#each c.user_sezionales as |s|}}\n              <span\n                role=\'button\'\n                class=\'button small\n                  {{if (is-equal-large this.indexContext.controller.sezionale s.id) \"success\"}}\' data-test-set-sezionale-3 {{on \'click\' (fn (mut this.indexContext.controller.sezionale) s.id)}}\n              >\n                {{s.prefix}} {{t \'N°\'}} {{s.suffix}}\n              </span>\n            {{/each}}\n          {{/each}}\n        {{else}}\n          {{#each this.session.me.user_sezionales as |s|}}\n            <span\n              role=\'button\'\n              class=\'button small\n                {{if (is-equal-large this.indexContext.controller.sezionale s.id) \"success\"}}\' data-test-set-sezionale-4 {{on \'click\' (fn (mut this.indexContext.controller.sezionale) s.id)}}\n            >\n              {{s.prefix}} {{t \'N°\'}} {{s.suffix}}\n            </span>\n          {{/each}}\n        {{/if}}\n      </div>\n      <div class=\'grid-block vertical\'>\n        <div class=\'grid-content\'>\n          <HasMany\n            @applicationController={{@applicationController}}\n            @relatedHasMany={{this.from_contacts}}\n            @relatedModelType=\'contact\'\n            @isEditable={{true}}\n            @showThumbnail={{true}}\n            @smallThumbnail={{true}}\n            @action={{this.addFromContact}}\n            @actionRemove={{this.removeFromContact}}\n            @wrapLabelSearchInput={{this.session.me.organization.contact_name}} data-test-add-from-contact-2 data-test-remove-from-contact-2\n          />\n        </div>\n      </div>\n      <h4 class=\'label hollow\'>\n        {{t \'filter\'}} {{t \'client\'}}\n      </h4>\n      <small class=\'float-right\'>\n        <a data-test-show-all-2 {{on \'click\' (fn this.showAll \'contact_id\')}}>\n          {{t \'all\'}}\n        </a>\n        -\n        <a data-test-only-me {{on \'click\' this.onlyMe}}>\n          {{t \'only mine\'}}\n        </a>\n      </small>\n      <div class=\'grid-block vertical\'>\n        <div class=\'grid-content\'>\n          <HasMany\n            @applicationController={{@applicationController}}\n            @relatedHasMany={{this.contacts}}\n            @relatedModelType=\'contact\'\n            @isEditable={{true}}\n            @showThumbnail={{true}}\n            @smallThumbnail={{true}}\n            @action={{this.addContact}}\n            @actionRemove={{this.removeContact}}\n            @wrapLabelSearchInput={{this.session.me.organization.contact_name}} data-test-add-contact data-test-remove-contact-2\n          />\n        </div>\n      </div>\n      {{#if this.defaultAssuranceLists}}\n        <h4 class=\'label hollow\'>\n          {{t \'insurance\'}}\n        </h4>\n        <div class=\'button-group\'>\n          {{#each this.defaultAssuranceLists as |df|}}\n            <span\n              class=\'button small\n                {{if\n                  (is-equal this.indexContext.controller.q (generate-id \"assurance:\" df.id))\n                  \"success\"\n                }}\'\n              role=\'button\'\n              data-test-set-pmethod-2\n              {{on \'click\' (fn this.setPMethod (generate-id \'assurance:\' df.id) undefined)}}\n            >\n              {{df.name}}\n            </span>\n          {{/each}}\n        </div>\n      {{/if}}\n    {{else}}\n      <h4 class=\'label hollow\'>\n        {{t \'filter\'}} {{this.session.me.organization.contact_name}}\n      </h4>\n      <small class=\'float-right\'>\n        <a data-test-only-me-2 {{on \'click\' this.onlyMe}}>\n          {{t \'only mine\'}}\n        </a>\n      </small>\n      <div class=\'grid-block vertical\'>\n        <div class=\'grid-content\'>\n          <HasMany\n            @applicationController={{@applicationController}}\n            @relatedHasMany={{this.contacts}}\n            @relatedModelType=\'contact\'\n            @isEditable={{true}}\n            @showThumbnail={{true}}\n            @smallThumbnail={{true}}\n            @action={{this.addContact}}\n            @actionRemove={{this.removeContact}}\n            @wrapLabelSearchInput={{this.session.me.organization.contact_name}} data-test-add-contact-2 data-test-remove-contact-3\n          />\n        </div>\n      </div>\n    {{/if}}\n  </:main>\n</BbModalModern>\n\n<BbModalModern\n  @isOpen={{this.showProductModal}}\n  @title={{t \'filter\'}}\n  @closeOnBackdrop={{true}}\n  @onClose={{fn (mut this.showProductModal) false}}\n  @zIndex=\'13\' data-test-set-show-product-modal-2\n>\n  <:main>\n    <h4 class=\'label hollow\'>\n      {{t \'filter\'}} {{this.session.me.organization.product_name}}\n    </h4>\n    <div class=\'grid-block vertical\'>\n      <div class=\'grid-content\'>\n        <HasMany\n          @applicationController={{@applicationController}}\n          @relatedHasMany={{this.products}}\n          @relatedModelType=\'product\'\n          @isEditable={{true}}\n          @showThumbnail={{true}}\n          @smallThumbnail={{true}}\n          @action={{this.addProduct}}\n          @actionRemove={{this.removeProduct}}\n          @wrapLabelSearchInput={{this.session.me.organization.product_name}} data-test-add-product data-test-remove-product-2\n        />\n      </div>\n    </div>\n  </:main>\n</BbModalModern>\n\n<BbPanel\n  @closeModal={{fn (mut this.selectCategorySlide) null}}\n  @title={{t \'list categories\'}}\n  @showModal={{this.selectCategorySlide}}\n  @zIndex=\'12\'\n>\n  <SelectCategory\n    @closeModal={{fn (mut this.selectCategorySlide) null}}\n    @fromIndex={{true}}\n    @showNotCatalog={{true}}\n    @actionSelect={{this.selectCategory}}\n    @applicationController={{@applicationController}} data-test-select-category-2\n  />\n</BbPanel>");

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
const SDI_STATES = Object.freeze([{
  name: 'only electronic',
  status: 'Elettroniche'
}, {
  name: 'sdi_status.HDO10',
  status: 'HDO10'
}, {
  name: 'sdi_status.HDO00',
  status: 'HDO00'
}, {
  name: 'sdi_status.HDO01',
  status: 'HDO01'
}, {
  name: 'sdi_status.HDO02',
  status: 'HDO02'
}, {
  name: 'sdi_status.HDO03',
  status: 'HDO03'
}, {
  name: 'sdi_status.HDO05',
  status: 'HDO05'
}, {
  name: 'sdi_status.HDO06',
  status: 'HDO06'
}, {
  name: 'sdi_status.HDO07',
  status: 'HDO07'
}, {
  name: 'sdi.not_send',
  status: 'Da inviare'
}]);

/**
 * TS (Tessera Sanitaria) status options
 * @constant {Array<{name: string, status: string}>}
 */
const TS_STATES = Object.freeze([{
  name: 'ts.sended',
  status: 'ts'
}]);

/**
 * Document types that support credit notes
 * @constant {Set<string>}
 */
const CREDIT_NOTE_DOCUMENT_TYPES = new Set(['invoice', 'receipt', 'expense']);

/**
 * Model names that support category filtering
 * @constant {Set<string>}
 */
const CATEGORY_MODEL_NAMES = new Set(['invoice', 'expense']);

/**
 * IndexFilter Component
 *
 * A comprehensive filter component for index/list views.
 * Supports filtering by contacts, products, categories, SDI status, and more.
 *
 * @class BbListFilterComponent
 * @extends Component
 *
 * @arg {Object} applicationController - Main application controller reference
 * @arg {string} [elementId] - Custom element ID for the filter
 * @arg {boolean} [showEventFilter=false] - Whether to show event filters
 */
let BbListFilterComponent = (_dec = task({
  restartable: true
}), _dec2 = task({
  enqueue: true
}), _class = class BbListFilterComponent extends Component {
  get contactIds() {
    return this._controller?.contact_id || [];
  }
  get fromContactIds() {
    return this._controller?.from_id || [];
  }
  get productIds() {
    return this._controller?.product_id || [];
  }
  get totalContactsCount() {
    return this.fromContactIds.length + this.contactIds.length;
  }

  /** @type {boolean} */

  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "indexContext", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    /** @type {string} */
    _initializerDefineProperty(this, "elementId", _descriptor4, this);
    /** @type {Array} */
    _initializerDefineProperty(this, "contacts", _descriptor5, this);
    /** @type {Array} */
    _initializerDefineProperty(this, "products", _descriptor6, this);
    /** @type {Array} */
    _initializerDefineProperty(this, "from_contacts", _descriptor7, this);
    _initializerDefineProperty(this, "showContactModal", _descriptor8, this);
    /** @type {boolean} */
    _initializerDefineProperty(this, "showProductModal", _descriptor9, this);
    /**
     * SDI status options (immutable)
     * @type {Array<{name: string, status: string}>}
     */
    this.sdiStates = SDI_STATES;
    /**
     * TS status options (immutable)
     * @type {Array<{name: string, status: string}>}
     */
    this.tsStates = TS_STATES;
    /**
     * Whether the filter panel is visible
     * @type {boolean}
     */
    _initializerDefineProperty(this, "showFilter", _descriptor0, this);
    // Slide-panel toggle flags written only from the template via `mut`.
    // They MUST be @tracked: as undeclared plain props their writes never
    // re-rendered the panel (Octane untracked-property regression class).
    _initializerDefineProperty(this, "eInv", _descriptor1, this);
    _initializerDefineProperty(this, "tsInv", _descriptor10, this);
    _initializerDefineProperty(this, "selectCategorySlide", _descriptor11, this);
    this.showFilter = !this.args.applicationController?.isSmallDevice;
    this.elementId = this.args.elementId ?? this._generateElementId();
    this.loadAllAsyncData.perform();
  }

  // ==================== Private Helpers ====================

  /**
   * Generates a unique element ID
   * @returns {string}
   * @private
   */
  _generateElementId() {
    return `index-filter-${Math.floor(Math.random() * 1000000)}`;
  }

  /**
   * Closes a ZfDropdown via the DOM by its element id.
   * Il pattern @zfUi={{this.x}} non funziona: ZfDropdown fa set(this,'zfUi',...)
   * e non riesce a scrivere indietro sull'arg, quindi this.zfStato resta undefined
   * e .close() è un no-op. Chiudiamo via DOM con lo stesso id passato a @id
   * (stesso approccio di change-status.js).
   * @param {string} id - The dropdown element id (matches @id / data-toggle)
   * @private
   */
  _closeDropdown(id) {
    const el = id && document.getElementById(id);
    if (!el?.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.data-dropdown.is-open')) {
      document.body.classList.remove('dropdown-open');
    }
  }

  /**
   * Safely gets the controller from indexContext
   * @returns {Object|null}
   * @private
   */
  get _controller() {
    return this.indexContext?.controller;
  }

  /**
   * Safely gets the model from the controller
   * @returns {Object|null}
   * @private
   */
  get _controllerModel() {
    return this._controller?.model;
  }

  /**
   * Parses a value to integer, returning null if invalid
   * @param {*} value - Value to parse
   * @returns {number|null}
   * @private
   */
  _parseId(value) {
    const raw = value !== null && value !== undefined && typeof value === 'object' ? value.id : value;
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  /**
   * Resets pagination to first page
   * @private
   */
  _resetPagination() {
    if (this._controller) {
      this._controller.pag = 1;
    }
  }

  /**
   * Updates a controller array property by adding an item
   * @param {string} propName - Property name on the controller
   * @param {*} item - Item to add
   * @private
   */
  _addToControllerArray(propName, item) {
    if (!this._controller) return;
    const currentArray = this._controller[propName] || [];
    this._controller[propName] = [...currentArray, item];
  }

  /**
   * Updates a controller array property by removing an item
   * @param {string} propName - Property name on the controller
   * @param {number} idToRemove - ID to remove from array
   * @private
   */
  _removeFromControllerArray(propName, idToRemove) {
    if (!this._controller) return;
    const currentArray = this._controller[propName] || [];
    this._controller[propName] = currentArray.filter(id => {
      const parsedId = this._parseId(id);
      return parsedId !== idToRemove;
    });
  }

  /**
   * Finds records by IDs, using cache when possible
   * @param {Array<string|number>} idArray - Array of IDs
   * @param {string} modelName - Ember Data model name
   * @returns {Promise<Array>}
   * @private
   */
  async _findAllByIds(idArray, modelName) {
    if (!Array.isArray(idArray) || idArray.length === 0) {
      return [];
    }
    const records = idArray.map(id => this.store.peekRecord(modelName, id));

    // If all records are in cache, return them immediately
    if (records.every(Boolean)) {
      return records;
    }

    // Fetch missing records in parallel. Catch per record: un id stale/cancellato
    // non deve far fallire l'intero set di chip (Promise.all reject-all).
    const results = await Promise.all(idArray.map((id, idx) => records[idx] ?? this.store.findRecord(modelName, id).catch(() => null)));
    return results.filter(Boolean);
  }

  // ==================== Tasks ====================

  /**
   * Loads all async data in parallel
   * @task
   */
  *loadAllAsyncData() {
    yield Promise.all([this.loadEntity.perform('contact_id', 'contact', 'contacts'), this.loadEntity.perform('product_id', 'product', 'products'), this.loadEntity.perform('from_id', 'contact', 'from_contacts')]);
  }

  /**
   * Loads a single entity type into a tracked property
   * @param {string} modelKey - Controller property containing IDs
   * @param {string} modelName - Ember Data model name
   * @param {string} propName - Component property to store results
   * @task
   */
  *loadEntity(modelKey, modelName, propName) {
    const ids = this._controller?.[modelKey];
    this[propName] = yield this._findAllByIds(ids, modelName);
  }

  // ==================== Computed Properties ====================

  /**
   * Whether to show event filters
   * @returns {boolean}
   */
  get showEventFilter() {
    return this.args.showEventFilter ?? false;
  }

  /**
   * Whether to show payment method selection
   * @returns {boolean}
   */
  get showSelectPayment() {
    return this._controllerModel?.documentType === 'payment';
  }

  /**
   * Whether to show category selection
   * @returns {boolean}
   */
  get showSelectCategory() {
    const modelName = this._controllerModel?.modelName;
    return modelName ? CATEGORY_MODEL_NAMES.has(modelName) : false;
  }

  /**
   * Whether to show credit note option
   * @returns {boolean}
   */
  get showCreditNote() {
    const documentType = this._controllerModel?.documentType;
    return documentType ? CREDIT_NOTE_DOCUMENT_TYPES.has(documentType) : false;
  }

  /**
   * Whether to show SDI status filter
   * @returns {boolean}
   */
  get showStatusSdi() {
    return this._controllerModel?.modelName === 'invoice';
  }

  /**
   * Gets category records from IDs
   * @returns {Array}
   */
  get category() {
    const categoryId = this._controller?.category_id;
    return this.peekRecordsFromIds(this.store, categoryId, 'category');
  }

  /**
   * Gets sub-category records from IDs
   * @returns {Array}
   */
  get sub_category() {
    const subCategoryId = this._controller?.sub_category_id;
    return this.peekRecordsFromIds(this.store, subCategoryId, 'sub_category');
  }

  // ==================== Element ID Getters ====================

  get zfPazFilter() {
    return `zf-paz-${this.elementId}`;
  }
  get zfOrFilter() {
    return `zf-or-${this.elementId}`;
  }
  get zfCFilter() {
    return `zf-cf-${this.elementId}`;
  }
  get zfCNoteFilter() {
    return `zf-cn-${this.elementId}`;
  }
  get zfStatoinvFilter() {
    return `zf-stato-inv-${this.elementId}`;
  }
  get zfEsitoFilter() {
    return `zf-esito-${this.elementId}`;
  }
  get zfPFilter() {
    return `zf-pf-${this.elementId}`;
  }

  // ==================== Public Methods ====================

  /**
   * Retrieves records from store by IDs (synchronous, cache only)
   * @param {Object} store - Ember Data store
   * @param {Array<string|number>} idArray - Array of IDs
   * @param {string} modelName - Model name
   * @returns {Array}
   */
  peekRecordsFromIds(store, idArray, modelName) {
    if (!Array.isArray(idArray)) {
      return [];
    }
    return idArray.map(itemId => store.peekRecord(modelName, itemId)).filter(Boolean);
  }

  /**
   * Gets default assurance list
   * @returns {Array|Promise<Array>}
   */
  get defaultAssuranceLists() {
    const assurances = this.store.peekAll('assurance');
    return assurances.length > 0 ? assurances : this.store.findAll('assurance');
  }

  /**
   * Gets default invoice lists based on application settings
   * @returns {Array|null}
   */
  get defaultInvoiceLists() {
    this.args.applicationController;
    const optionField = this.session.option_field;
    const defaultFrom = optionField?.default_invoice_from;
    const defaultLists = optionField?.default_invoice_lists;
    if (!defaultFrom && !defaultLists) {
      return null;
    }
    let defFromUser = null;
    if (defaultFrom) {
      defFromUser = this._buildDefaultFromUser(defaultFrom);
    }

    // Handle array-based default lists
    if (Array.isArray(defaultLists)) {
      return this._mergeDefaultLists(defaultLists, defFromUser);
    }

    // Handle user-specific default lists (object keyed by user ID)
    const me = this.session.me;
    if (me?.id && defaultLists?.[me.id]) {
      const userLists = defaultLists[me.id];
      if (Array.isArray(userLists)) {
        return this._mergeDefaultLists(userLists, defFromUser);
      }
      return userLists;
    }
    return defFromUser ? [defFromUser] : null;
  }

  /**
   * Builds a default from user object
   * @param {string|number} defaultFrom - Contact ID
   * @returns {Object}
   * @private
   */
  _buildDefaultFromUser(defaultFrom) {
    const cachedContact = this.store.peekRecord('contact', defaultFrom);
    return {
      name: cachedContact?.label ?? '',
      id: defaultFrom
    };
  }

  /**
   * Merges default lists with the default from user
   * @param {Array} lists - Existing lists
   * @param {Object|null} defFromUser - Default from user object
   * @returns {Array}
   * @private
   */
  _mergeDefaultLists(lists, defFromUser) {
    if (!defFromUser?.id) {
      return lists;
    }

    // The two `option_field` keys store the SAME issuer id in different types:
    // `default_invoice_lists` entries are written as strings (section-invoice-options.js
    // `_normEntry`: `const id = String(entry?.id ?? '')`), while the scalar
    // `default_invoice_from` is written as a number (settings/invoice.js:293-294
    // `parseInt(def.id, 10)`, and ember-poppix edits it through an `<Input @type='number'>`).
    // A strict compare therefore never matched and the default issuer was appended a
    // SECOND time: the "emessa da" filter listed it twice, the duplicate labelled
    // `cachedContact?.label ?? ''` — a blank option whenever that contact was not
    // already in the store.
    const defFromUserId = String(defFromUser.id);
    const includesDefFromUser = lists.some(item => String(item?.id) === defFromUserId);
    return includesDefFromUser ? lists : [...lists, defFromUser];
  }

  // ==================== Actions ====================

  /**
   * Sets the SDI status filter
   * @param {string|null} sdi_status - Status to set
   */
  setStatus(sdi_status = null) {
    if (!this._controller) return;
    this._controller.sdi_status = sdi_status;
    if (!sdi_status) {
      this._controller.success = null;
    }
    this._resetPagination();
    this._closeDropdown(this.zfStatoinvFilter);
  }

  /**
   * Sets the success filter
   * @param {*} success - Success value to set
   */
  setSuccess(success = null) {
    if (!this._controller) return;
    this._controller.success = success;
    this._resetPagination();
    this._closeDropdown(this.zfStatoinvFilter);
  }

  /**
   * Selects category and sub-category filters
   * @param {Object|null} category - Category object
   * @param {Object|null} sub_category - Sub-category object
   */
  selectCategory(category, sub_category) {
    if (!this._controller) return;
    this._controller.category_id = category?.id != null ? [category.id] : null;
    this._controller.sub_category_id = sub_category?.id != null ? [sub_category.id] : null;
    this._resetPagination();
  }

  /**
   * Sets payment method filter
   * @param {string} name - Filter name
   * @param {*} pm - Payment method
   */
  setPMethod(name, pm) {
    if (!this._controller) return;
    const currentQ = this._controller.q;
    this._controller.q = currentQ === name ? null : name;
    set(this._controller, 'pMethod', pm);
    this._resetPagination();
    this._closeDropdown('pMethodList');
  }

  /**
   * Filters to show only current user's records
   */
  onlyMe() {
    const me = this.session.me;
    if (!this._controller || !me?.id) return;
    this._controller.contact_id = [me.id];
    this._resetPagination();
    this.contacts = [me];
    this.showContactModal = false;
    this.indexContext.searchItem.perform();
  }

  /**
   * DDAU callback for <BbPeriodPicker>. The Classic component two-way-bound
   * `from_date`/`to_date` onto the controller; the Glimmer version emits the
   * selected range through `@action`, so write it back here and re-search.
   */
  setPeriod(fromDate, toDate) {
    if (!this._controller) return;
    this._controller.from_date = fromDate ?? null;
    this._controller.to_date = toDate ?? null;
    this._resetPagination();
    this.indexContext.searchItem.perform();
  }

  /**
   * DDAU setters for the custom-range FromtoDate inside DropSelectPeriod —
   * update the controller field without searching; `setRange` reads them back
   * and commits through `setPeriod`.
   */
  setFromDate(fromDate) {
    if (this._controller) this._controller.from_date = fromDate ?? null;
  }
  setToDate(toDate) {
    if (this._controller) this._controller.to_date = toDate ?? null;
  }

  /**
   * Adds a contact to the filter
   * @param {string|number} item - Contact ID to add
   */
  addContact(item) {
    if (!item) return;
    this._addToControllerArray('contact_id', item);
    this._resetPagination();
    this.loadAllAsyncData.perform();
    this.showContactModal = false;
  }

  /**
   * Removes a contact from the filter
   * @param {string|number} item - Contact ID to remove
   */
  removeContact(item) {
    if (!item) return;
    const id = this._parseId(item);
    if (id !== null) {
      this._removeFromControllerArray('contact_id', id);
    }
    this._resetPagination();
    this.loadAllAsyncData.perform();
  }

  /**
   * Filters "from" field to show only current user
   */
  onlyMeFrom() {
    const me = this.session.me;
    if (!this._controller || !me?.id) return;
    this._controller.from_id = [me.id];
    this._resetPagination();
    this.from_contacts = [me];
    this.showContactModal = false;
    this.indexContext.searchItem.perform();
  }

  /**
   * Clears a specific filter to show all records
   * @param {string} v - Property name to clear
   */
  showAll(v = 'contact_id') {
    if (!this._controller) return;
    this._controller[v] = [];
    this._resetPagination();
    this.loadAllAsyncData.perform();
  }

  /**
   * Adds a "from" contact filter
   * @param {string|number} item - Contact ID
   */
  addFromContact(item) {
    if (!this._controller) return;
    if (item) {
      const id = this._parseId(item);
      this._controller.from_id = id !== null ? [id] : [];
    } else {
      this._controller.from_id = [];
    }
    this._resetPagination();
    this.loadAllAsyncData.perform();
    this.showContactModal = false;
  }

  /**
   * Removes a "from" contact from filter
   * @param {string|number} item - Contact ID to remove
   */
  removeFromContact(item) {
    if (item) {
      const id = this._parseId(item);
      if (id !== null) {
        this._removeFromControllerArray('from_id', id);
      }
    }
    this._resetPagination();
    this.loadAllAsyncData.perform();
  }

  /**
   * Adds a product to the filter
   * @param {string|number} item - Product ID to add
   */
  addProduct(item) {
    if (item) {
      const id = this._parseId(item);
      if (id !== null) {
        this._addToControllerArray('product_id', id);
      }
    }
    this._resetPagination();
    this.loadAllAsyncData.perform();
    this.showProductModal = false;
  }

  /**
   * Removes a product from the filter
   * @param {string|number} item - Product ID to remove
   */
  removeProduct(item) {
    if (!item) return;
    const id = this._parseId(item);
    if (id !== null) {
      this._removeFromControllerArray('product_id', id);
    }
    this._resetPagination();
    this.loadAllAsyncData.perform();
  }

  /**
   * Sets the event type filter
   * @param {string} type - Event type
   */
  setType(type = 'events') {
    if (!this._controller) return;
    this._controller.gdpr = null;
    this._controller.type = type;
    this._resetPagination();
  }

  /**
   * Sets the GDPR filter
   * @param {*} gdpr - GDPR value
   */
  setGdpr(gdpr = null) {
    if (!this._controller) return;
    this._controller.type = 'events';
    this._controller.gdpr = gdpr;
    this._resetPagination();
  }

  /**
   * Clears all filters shown in the chip strip (contacts, from_contacts, products, category).
   * Does not touch q, all_any, date range, or other non-chip filters.
   */
  clearSdiStatus() {
    if (!this._controller) return;
    this._controller.sdi_status = null;
    this._resetPagination();
    this.indexContext.searchItem.perform();
  }
  clearAllFilters() {
    if (!this._controller) return;
    this._controller.contact_id = [];
    this._controller.from_id = [];
    this._controller.product_id = [];
    this._controller.sdi_status = null;
    this.selectCategory(null, null);
    this._resetPagination();
    this.loadAllAsyncData.perform();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "indexContext", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "elementId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "contacts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "products", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "from_contacts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showContactModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showProductModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "showFilter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "eInv", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "tsInv", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectCategorySlide", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "loadAllAsyncData", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "loadAllAsyncData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadEntity", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "loadEntity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setStatus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCategory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onlyMe", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onlyMe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFromDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFromDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setToDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setToDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addContact", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addContact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeContact", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeContact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onlyMeFrom", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onlyMeFrom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addFromContact", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addFromContact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeFromContact", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeFromContact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addProduct", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeProduct", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeProduct"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setGdpr", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setGdpr"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSdiStatus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSdiStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearAllFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearAllFilters"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbListFilterComponent);

export { BbListFilterComponent as default };
//# sourceMappingURL=bb-list-filter.js.map
